import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CategoryService} from '../../shared/services/category.service';
import {CourseService} from '../../shared/services/course.service';
import {UniversityService} from '../../shared/services/university.service';
import {EbookService} from '../../shared/services/ebook.service';

@Component({
  selector: 'app-e-book',
  templateUrl: './e-book.component.html',
  styleUrls: ['./e-book.component.scss']
})
export class EBookComponent implements OnInit {

  showSearch = false;
  id: any;
  data: any;
  categories: any;
  universities: any = [];
  coursesList: any = [];
  semesters: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  inputTypePassword = 'password';
  submitted: any = false;
  submitting: any = false;
  searchForm: FormGroup;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };
  courses = [];

  constructor(private router: Router,
              private _coreSidebarService: CoreSidebarService,
              public modalService: NgbModal,
              private fb: FormBuilder,
              private categoryService: CategoryService,
              private ebookService: EbookService,
              private universityService: UniversityService,
              private courseService: CourseService) {
  }

  ngOnInit(): void {
    this.refresh();
    this.getCategory();
    this.getUniversities();
    this.getCourses();
  }

  toggleSidebar(): void {
    this._coreSidebarService.getSidebarRegistry('add-ebook').toggleOpen();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'name': [''],
      'category_id': [''],
      'university_id': [''],
      'course_id': [''],
      'semester': [''],
    });
    this.get();
  }
  getCategory() {
    this.categories = [];
    const params = {};
    this.categoryService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.categories = res['data'];
      }
    }, error => {
      this.categories = [];
    });
  }
  getUniversities() {
    this.universities = [];
    const params = {};
    this.universityService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.universities = res['data'];
      }
    }, error => {
      this.universities = [];
    });
  }
  getCourses() {
    this.coursesList = [];
    const params = {};
    this.courseService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.coursesList = res['data'];
      }
    }, error => {
      this.coursesList = [];
    });
  }
  add(): void {
    this.data = undefined;
    this.toggleSidebar();
  }

  getData(valueSubmit: any): void {
    if (valueSubmit) {
      this.get({page: 1, total: null, perpage: 15, pages: null});
      this.toggleSidebar();
    }
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.per_page = this.pagination.perpage;
    this.submitting = true;
    this.courses = [];
    this.ebookService.get(params).subscribe(data => {
      if (data && data['data'].length > 0) {
        this.courses = data['data'];
        this.pagination = {
          page: data.current_page,
          total: data.total,
          perpage: data.per_page,
          pages: data.last_page,
        };
      } else {
        this.courses = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  search() {
    const params = {
      'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
      'category_id': (this.searchForm.value && this.searchForm.value.category_id) ? this.searchForm.value.category_id : '',
      'university_id': (this.searchForm.value && this.searchForm.value.university_id) ? this.searchForm.value.university_id : '',
      'course_id': (this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
      'semester': (this.searchForm.value && this.searchForm.value.semester) ? this.searchForm.value.semester : '',
    };
    this.get(params);
  }

  onPageChange(page) {
    this.pagination.page = page;
    const params = {
      'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
      'category_id': (this.searchForm && this.searchForm.value && this.searchForm.value.category_id) ? this.searchForm.value.category_id : '',
      'university_id': (this.searchForm && this.searchForm.value && this.searchForm.value.university_id) ? this.searchForm.value.university_id : '',
      'course_id': (this.searchForm && this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
      'semester': (this.searchForm && this.searchForm.value && this.searchForm.value.semester) ? this.searchForm.value.semester : '',
    };
    this.get(params);
  }

  edit(data) {
    this.data = data;
    this.toggleSidebar();
  }

  updateStatus(status, data) {
    this.submitted = true;
    if (this.submitted) {
      const params = {
        'status': status
      };
      this.submitting = true;
      this.ebookService.updateStatus(data.unique_id, params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
        this.modalService.dismissAll('');
        this.get();
      }, error => {
        this.submitting = false;
        this.submitted = false;
        this.id = undefined;
      });
    }
  }
}
